import BoxTotal from '../Components/BoxTotal'
import { storagePage } from '../storage'
import { CashboxUserData } from '../types'

export default function TotalSale() {
    const cashboxUser = storagePage.cashboxUser as CashboxUserData
    const value =
        cashboxUser.amount_sale.total + cashboxUser.amount_collection.total

    return (
        <BoxTotal
            w={{ base: '100%', xl: '70%' }}
            title="Total cobrado"
            value={value}
            paymentAmounts={cashboxUser.payment_amounts}
            wTarget={null}
        />
    )
}
